import React from 'react';
import classNames from 'classnames';
import './PasswordValidation.pcss';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

export type Props = {
  text: string;
  className?: string;
  childClassName?: string;
  error?: boolean;
};

export const PasswordValidation = ({
  text,
  className,
  error,
  childClassName,
}: Props) => {
  return (
    <div className={classNames('password-validation__item-wrapper', className)}>
      {error ? (
        <ExclamationCircleOutlined className="password-validation__error_icon" />
      ) : (
        <CheckCircleOutlined className="password-validation__check_icon" />
      )}
      <span
        className={classNames(
          'password-validation__text-item',
          error ? 'text-item-error' : '',
          childClassName,
        )}
      >
        {text}
      </span>
    </div>
  );
};
